import { daily, pool, ymd } from '../socialStudio/socialStudio.api';

// Clima diario de los últimos 31 días + hoy (Open-Meteo, sin clave).
export async function loadClimaMes(lat, lng) {
  const aprox = !lat || !lng;
  const la = aprox ? -34.6037 : lat, lo = aprox ? -58.3816 : lng;
  try {
    const u = `https://api.open-meteo.com/v1/forecast?latitude=${la}&longitude=${lo}&daily=temperature_2m_max,temperature_2m_min,precipitation_sum,weather_code&past_days=31&forecast_days=1&timezone=America%2FArgentina%2FBuenos_Aires`;
    const d = (await (await fetch(u)).json()).daily;
    const dias = d.time.map((fecha, i) => ({
      fecha, tmax: d.temperature_2m_max[i], tmin: d.temperature_2m_min[i], lluvia: d.precipitation_sum[i] || 0, code: d.weather_code[i],
    })).filter((x) => x.tmax != null);
    return { dias, aprox };
  } catch (e) {
    return null;
  }
}

// Cuántas fotos registró la cámara cada uno de los últimos `days` días.
export async function loadReportabilidad(feedID, days = 30, onProgress) {
  const hoy = new Date();
  const fechas = [];
  for (let i = days; i >= 1; i--) { const d = new Date(hoy); d.setDate(d.getDate() - i); fechas.push(d); }
  let done = 0;
  const res = await pool(fechas, 5, async (d) => {
    const list = await daily(feedID, d);
    done++; if (onProgress) onProgress(done, fechas.length);
    const ult = list.reduce((a, b) => (!a || b.ts > a ? b.ts : a), null);
    return { fecha: ymd(d), count: list.length, ultima: ult };
  });
  return { dias: res };
}

export const iconoClima = (code) => (code === 0 ? '☀️' : code <= 2 ? '⛅' : code === 3 ? '☁️' : code <= 48 ? '🌫️' : code <= 67 ? '🌧️' : code <= 77 ? '❄️' : code <= 82 ? '🌦️' : '⛈️');
